import React from "react";
import {TRANSACTION_TYPE_VALUES} from "../../../../constants";

import PortfolioTradeV2 from "../PortfolioTradeV2";
import SavingsPlanTrade from "../SavingsPlansTrade/SavingsPlanTrade";
import PayoutPlanTrade from "../PayoutPlansTrade/PayoutPlanTrade";
import SwitchPlanTrade from "../SwitchPlansTrade/SwitchPlanTrade";

const TRADING_TABS = [
  TRANSACTION_TYPE_VALUES.BUY,
  TRANSACTION_TYPE_VALUES.SELL,
  TRANSACTION_TYPE_VALUES.SWITCH,
];


/**
 * Renders the content for the active tab — either a trading action or a payment plan.
 */
const PortfolioTabContent = ({
  activeTab,
  portfolio,
  handlePortfolioChange,
  minDepositDate,
  dataService,
  isVirtual,
  isNewVirtual,
  defaults,
  updateDefaults,
  showSectionsWithoutTransactions,
  showTradingActions,
  isCustomerApp,
  allowedPortfolioTradeOptions,
  resource,
}) => {
  if (TRADING_TABS.includes(activeTab)) {
    return (
      <PortfolioTradeV2
        key={portfolio.portfolioId}
        portfolio={portfolio}
        handlePortfolioChange={handlePortfolioChange}
        minDepositDate={minDepositDate}
        customerId={dataService.customer_id}
        dataService={dataService}
        isVirtual={isVirtual}
        isNewVirtual={isNewVirtual}
        isCustomerApp={isCustomerApp}
        activeTradeOption={activeTab}
        allowedTradeOptions={allowedPortfolioTradeOptions}
        resource={resource}
        showSectionsWithoutTransactions={showSectionsWithoutTransactions}
        showTradingActions={showTradingActions}
      />
    );
  }

  switch (activeTab) {
    case TRANSACTION_TYPE_VALUES.SAVINGS_PLAN:
      return (
        <SavingsPlanTrade
          key={portfolio.portfolioId}
          portfolio={portfolio}
          handlePortfolioChange={handlePortfolioChange}
          customer_id={dataService.customer_id}
          defaults={defaults.savings_plan || {}}
          updateDefaults={updateDefaults}
          dataService={dataService}
          isVirtual={isVirtual}
          isCustomerApp={isCustomerApp}
        />
      );

    case TRANSACTION_TYPE_VALUES.PAYOUT_PLAN:
      return (
        <PayoutPlanTrade
          key={portfolio.portfolioId}
          portfolio={portfolio}
          handlePortfolioChange={handlePortfolioChange}
          customer_id={dataService.customer_id}
          defaults={defaults.payout_plan || {}}
          updateDefaults={updateDefaults}
          dataService={dataService}
          isVirtual={isVirtual}
          isCustomerApp={isCustomerApp}
        />
      );

    case TRANSACTION_TYPE_VALUES.SWITCH_PLAN:
      return (
        <SwitchPlanTrade
          key={portfolio.portfolioId}
          portfolio={portfolio}
          handlePortfolioChange={handlePortfolioChange}
          customer_id={dataService.customer_id}
          defaults={defaults.switch_plan || {}}
          updateDefaults={updateDefaults}
          dataService={dataService}
          isVirtual={isVirtual}
          isCustomerApp={isCustomerApp}
        />
      );

    default:
      return null;
  }
};

export default PortfolioTabContent;
